export default "__VITE_ASSET__e9935f53__"